"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENGINEER_ROLES = exports.EngineerRole = void 0;
var EngineerRole;
(function (EngineerRole) {
    EngineerRole["EE_CE"] = "ee-ce";
    EngineerRole["EE_SR_CE"] = "ee-sr-ce";
    EngineerRole["EE_CA"] = "ee-ca";
    EngineerRole["EE_SR_CA"] = "ee-sr-ca";
    EngineerRole["EE_LEAD_CA"] = "ee-lead-ca";
    EngineerRole["EE_SR_ENG_MANAGER"] = "ee-sr-eng-manager";
    EngineerRole["DIRECTOR"] = "director";
})(EngineerRole || (exports.EngineerRole = EngineerRole = {}));
exports.ENGINEER_ROLES = Object.values(EngineerRole).sort();
//# sourceMappingURL=EngineerRole.js.map